module.exports = __webpack_public_path__ + "assets/img/21_1518.580049f0.jpg";